module.exports = __webpack_public_path__ + "4bcf68a261fcb4676c8e47dce284f90a.png";


//////////////////
// WEBPACK FOOTER
// ./content/help/research/insilico/scoring-img/img4.png
// module id = 1323
// module chunks = 0